import { AuthorizationLevel } from '@/types/schema';

import { WaterfallAccess } from './RoleViewer.types';

export const waterfallOptions = [
  {
    value: WaterfallAccess.View,
    label: 'View only',
    helpText:
      'Can view the Waterfall tab and all related views. Cannot create new waterfalls or edit waterfall diagrams. Cannot add waterfall-related slides to the client presentation.',
  },
  {
    value: WaterfallAccess.Presentation,
    label: 'Presentation',
    helpText:
      'Can view the Waterfall tab and all related views. Cannot create new waterfalls or edit waterfall diagrams. Can add waterfall-related slides to the client presentation.',
  },
  {
    value: WaterfallAccess.Editor,
    label: 'Editor',
    helpText:
      'Can create new waterfalls and hypothetical scenarios, edit waterfall diagrams, and add waterfall-related slides to the client presentation.',
  },
];

export const dispositiveProvisionsOptions = [
  {
    value: AuthorizationLevel.View,
    label: 'View only',
    helpText: 'Can view but cannot edit dispositive provisions.',
  },
  {
    value: AuthorizationLevel.Editor,
    label: 'Editor',
    helpText: 'Can view and edit dispositive provisions.',
  },
];

export const brandingOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Can read current branding but cannot make changes',
  },
  {
    value: AuthorizationLevel.Editor,
    label: 'Editor',
    helpText: 'Can update logos, colors, and copy',
  },
];

export const employeesOptions = [
  {
    value: AuthorizationLevel.View,
    label: 'View',
    helpText:
      'Can view and assign tasks to employees but cannot create or edit',
  },
  {
    value: AuthorizationLevel.Editor,
    label: 'Editor',
    helpText: 'Can create, edit, and manage employees but cannot assign roles',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Admin',
    helpText: 'Full employee management including role assignments',
  },
];

export const collaboratorsOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Cannot see or manage external collaborators',
  },
  {
    value: AuthorizationLevel.View,
    label: 'View',
    helpText: 'Can view collaborator list and contact info',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Admin',
    helpText: 'Can invite, manage, and deactivate collaborators',
  },
];

export const householdsOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Cannot access any client data or households',
  },
  {
    value: AuthorizationLevel.View,
    label: 'View',
    helpText: 'Read-only access to assigned households and client data',
  },
  {
    value: AuthorizationLevel.Editor,
    label: 'Editor',
    helpText:
      'Can edit client data, documents, and tasks for assigned households',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Admin',
    helpText:
      'Full client management including deleting households and changing ownership',
  },
];

export const auditLogsOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Cannot access system activity logs',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Admin',
    helpText: 'Can view and export audit log entries',
  },
];

export const presentationTemplatesOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Cannot manage tenant presentation templates',
  },
  {
    value: AuthorizationLevel.View,
    label: 'View',
    helpText: 'Can view tenant presentation templates but cannot manage them',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Manage',
    helpText: 'Can create, edit, and delete tenant presentation templates',
  },
];

export const rolesOptions = [
  {
    value: AuthorizationLevel.None,
    label: 'None',
    helpText: 'Cannot view or manage roles and permissions',
  },
  {
    value: AuthorizationLevel.View,
    label: 'View',
    helpText: 'Can view roles and their permissions but cannot edit',
  },
  {
    value: AuthorizationLevel.Editor,
    label: 'Editor',
    helpText: 'Can create and edit roles but cannot assign them to employees',
  },
  {
    value: AuthorizationLevel.Admin,
    label: 'Admin',
    helpText: 'Full role management including assigning roles to employees',
  },
];
